// extracted by mini-css-extract-plugin
export default {"dialogTitle":"PuiDialog_dialogTitle__ZZJM2"};